import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import CalmButton from './CalmButton'
import history from '../utilties/history'
import { surveyNavigationSelector } from '../redux/selectors'

const useStyles = makeStyles((theme) => ({
	headerTopBar: {
		padding: '6px 0',
		[theme.breakpoints.down('sm')]: {
			padding: '15px 0 0 0',
			'& > div': {
				margin: '0 0 15px 0'
			}
        }
	},

}))

const SurveySwitchHeader = ({
	surveyNavigation,
	onSkipClick,
	intl
}) => {
	const classes = useStyles();
	const [nextSurvey, setNextSurvey] = useState(null)

	const openSurveyPage = () => {
		if (nextSurvey) {
			history.push(`/survey/${nextSurvey.caseId}/${nextSurvey.protocolId}/${nextSurvey.surveyInstanceId}/${nextSurvey.surveyId}`)
		}
	}

	useEffect(
		() => {
			if (!!surveyNavigation) {
				let utc = (new Date()).getTime()
				setNextSurvey({
					surveyId: !!surveyNavigation.nextSurveyId ? surveyNavigation.nextSurveyId : surveyNavigation.surveyId,
					surveyInstanceId: !!surveyNavigation.nextSurveyInstanceId ? surveyNavigation.nextSurveyInstanceId : surveyNavigation.surveyInstanceId,
					protocolId: !!surveyNavigation.nextProtocolId ? surveyNavigation.nextProtocolId : surveyNavigation.protocolId,
					protocolName: !!surveyNavigation.nextProtocolName ? surveyNavigation.nextProtocolName : surveyNavigation.protocolName,
					surveyTitle: !!surveyNavigation.nextSurveyTitle ? surveyNavigation.nextSurveyTitle : surveyNavigation.surveyTitle,
					dueUnit: !!surveyNavigation.nextDueUnit ? surveyNavigation.nextDueUnit : surveyNavigation.dueUnit,
					dueValue: !!surveyNavigation.nextDueValue ? surveyNavigation.nextDueValue : surveyNavigation.dueValue,
					expiresUtc: !!surveyNavigation.nextExpiresUtc ? surveyNavigation.nextExpiresUtc : surveyNavigation.expiresUtc,
					dueDate: !!surveyNavigation.nextDueDate ? surveyNavigation.nextDueDate : surveyNavigation.dueDate,
					caseId: !!surveyNavigation.nextCaseId ? surveyNavigation.nextCaseId : surveyNavigation.caseId,
					isOverdue: !!surveyNavigation.nextDueDate ? (new Date(surveyNavigation.nextDueDate)).getTime() < utc : (new Date(surveyNavigation.dueDate)).getTime() < utc
				})
			}
		},
		[surveyNavigation]
	)

	return (
		<Grid
			data-testid="patient-detail-header" direction='row' className={classes.headerTopBar}
			container justify="space-between" alignItems="center" style={{ width: '100%' }}>
			<Grid item xs={12} sm={8}>
				{
					!!nextSurvey
					&& <Typography
						data-testid="patient-detail-header-protocol"
						variant="h1" style={{
							fontSize: '18px',
							color: '#fff',
							fontWeight: 400
						}}>

						{
							nextSurvey.isOverdue
							&& intl.formatMessage({ id: 'app.dashboard.overdueSurvey' }, {
								surveyTitle: nextSurvey.surveyTitle,
								protocolName: nextSurvey.protocolName
							})
						}
						{
							!nextSurvey.isOverdue
							&& intl.formatMessage({ id: 'app.dashboard.dueSurvey' }, {
								surveyTitle: nextSurvey.surveyTitle,
								protocolName: nextSurvey.protocolName
							})
						}
					</Typography>
				}
			</Grid>
            <Grid item xs={12} sm={4} style={{ textAlign:'right' }} data-print="none">
				<CalmButton
					style={{ minWidth: '150px' }}
					size="small"
					color="primary"
					variant="contained"
					onClick={openSurveyPage}
				>
					{intl.formatMessage({ id: 'app.dashboard.completeSurvey' })}
				</CalmButton>
				<CalmButton
					style={{ minWidth: '100px' }}
					size="small"
					color="primary"
					variant="outlined"
					onClick={onSkipClick}
				>
					{intl.formatMessage({ id: 'app.dashboard.skipSurvey' })}
				</CalmButton>
            </Grid>
		</Grid>
	)
}

const mapStateToProps = (state, ownProps) => ({
	surveyNavigation: surveyNavigationSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(SurveySwitchHeader)
